/**
 * View Expansion - Handles loading view subfolders (e.g. Columns)
 */

import {
  DatabaseExplorerNode,
  DatabaseObjectTreeNode,
  createColumnsFolderNode,
} from '../../explorer/models/DatabaseTreeModels';

export interface LoadViewSubfoldersOptions {
  node: DatabaseObjectTreeNode;
  updateNode: (nodeId: string, updates: Partial<DatabaseExplorerNode>) => void;
}

/**
 * Loads standard subfolders for a view node when it's expanded.
 * Currently only Columns are supported.
 */
export function loadViewSubfolders({ node, updateNode }: LoadViewSubfoldersOptions) {
  if (node.children && node.children.length > 0) {
    return;
  }

  const { objectDetails } = node.metadata;
  const connectionId = objectDetails.connectionId;
  const database = objectDetails.metadata?.database as string | undefined;
  const schema = objectDetails.schema;
  const viewName = objectDetails.name;

  if (!database) {
    return;
  }

  const columnsFolder = createColumnsFolderNode(connectionId, database, schema, viewName, node.id);

  updateNode(node.id, {
    children: [columnsFolder],
    isExpanded: true,
  });
}

